import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Yasuo mesh — wind swordsman silhouette. */
export function createYasuoMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x38bdf8 : 0xf87171;
  const bodyMat = new MeshStandardMaterial({ color: 0x1e293b, roughness: 0.45 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.3, metalness: 0.4 });
  const body = new Mesh(new ConeGeometry(0.5, 1.95, 10), bodyMat);
  body.position.y = 1.15;
  group.add(body);
  const head = new Mesh(new SphereGeometry(0.34, 12, 12), trimMat);
  head.position.y = 2.35;
  group.add(head);
  const sword = new Mesh(new CylinderGeometry(0.06, 0.06, 0.85, 6), trimMat);
  sword.rotation.z = Math.PI / 5;
  sword.position.set(0.55, 1.4, 0.15);
  group.add(sword);
  return group;
}
